define(() => {

    /**
     * Active class for Items
     * @type {string}
     */
    const activeClassItem = 'main_nav__item--active';

    /**
     * Active class for links
     * @type {string}
     */
    const activeClassAnchor = 'main_nav__link--active';

    /**
     * Assigns active class to all links with active page URL inside container.
     *
     * @param menuElement
     * @param activePageURL
     * @constructor
     */
    function ActiveLinkChecker(menuElement, activePageURL) {
        const menu = menuElement;
        const item = document.querySelector('li[data-menu-link="' + activePageURL + '"]');

        if (!item) {
            return false;
        }

        addClass(item);
    }

    /**
     * Recursively adds classes.
     *
     * @param item
     */
    function addClass(item) {
        item.classList.add(activeClassItem);
        item.firstElementChild.classList.add(activeClassAnchor);

        if (getParent(item)) {
            addClass(getParent(item));
        }
    }

    /**
     * Returns parent node two levels up. Returns Null if none with correct attribute.
     *
     * @param item
     * @return {*}
     */
    function getParent(item) {
        const parent = item.parentNode.parentNode;

        if (!parent.hasAttribute('data-menu-link')) {
            return null;
        }

        return parent;
    }

    return ActiveLinkChecker;
});
